module.exports = __webpack_public_path__ + "static/media/kinkhao_02_thumb.85c70835.png";